const roleList = [
{key: "FBSUSR",value: "Business User"},
{key: "FAGADN",value: "Agency Admin"},
];

export default roleList;
